import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/seo';
import PostItem from '../components/PostItem';
import TitlePage from '../components/TitlePage';
import LocalizedLink from '../components/LocalizedLink';
import useTranslations from '../components/useTranslations';

import * as S from '../components/ListWrapper/styled';

const Index = ({ data: { allMarkdownRemark } }) => {
  // useTranslations is aware of the global context (and therefore also "locale")
  // so it'll automatically give back the right translations
  const {
    hello,
    subline,
    category,
    latestPosts,
    allPosts,
  } = useTranslations();

  const postList = allMarkdownRemark.edges;

  return (
    <div className="homepage">
      <SEO title="Home" />
      <TitlePage text="Welcome to Supsim Project Site" />
      <p>
          The concept of two-predictor suppressor effects has attracted attention for several decades. Suppression situations
          are characterized by anything but agreement as it is evident from controversy over terminology
          (<a href="https://amstat.tandfonline.com/doi/abs/10.1198/000313005X41337">Friedman & Wall, 2005</a>), definition,
          and interpretation in the literature (<a href="https://psycnet.apa.org/record/1975-30852-000">Cohen & Cohen, 1975</a>;
          <a href="https://psycnet.apa.org/buy/1991-20289-001">Tzelgov & Henik, 1991</a>;
          <a href="https://www.tandfonline.com/doi/abs/10.1080/00031305.1997.10473587">Sharpe & Roberts, 1997</a>;
          <a href="https://www.tandfonline.com/doi/abs/10.1198/000313001750358437">Shieh, 2001</a>;
          <a href="https://www.tandfonline.com/doi/abs/10.1198/0003130031090">Lynn, 2003</a>).
          This project aims to shed light on our understanding of suppression situations by taking a closer look at the
          underlying mathematical concepts as well as simulating numerous situations with or without suppression.
          <a href="/project">Continue reading about this project...</a>
      </p>
      <hr style={{ margin: `2rem 0` }} />
      <p>
          Supsim was presented in the MSA 2021 Conference at the University of Lodz, Poland:
          <a href="https://youtu.be/6K82yDp-fNM"><img src="https://img.youtube.com/vi/6K82yDp-fNM/hqdefault.jpg" alt="Watch the video"></img></a>
      </p>
      <hr style={{ margin: `2rem 0` }} />
      <h2>
        <strong>Recommended reading</strong>
      </h2>

      <br />

      <S.ListWrapper>
        {postList.map(
          ({
            node: {
              frontmatter: {
                background,
                category,
                date,
                description,
                title,
                image,
              },
              timeToRead,
              fields: { slug },
            },
          }) => (
              <PostItem
                slug={slug}
                background={background}
                category={category}
                date={date}
                timeToRead={timeToRead}
                title={title}
                description={description}
                image={image}
                key={slug}
              />
            ),
        )}
      </S.ListWrapper>

      <br />

    </div>
  );
};

export default Index;

export const query = graphql`
  query Index($locale: String!, $dateFormat: String!, ) {
    allMarkdownRemark(
      filter: {
        fields: { locale: { eq: $locale } }
        fileAbsolutePath: {regex: "/(pages)\/.*\\.md$/"}
      }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 2
    ) {
      edges {
        node {
          frontmatter {
            title
            description
            category
            background
            image
            date(formatString: $dateFormat)

          }
          timeToRead
          fields {
            locale
            slug
          }
        }
      }
    }
  }
`;
